import { useState } from "react";
import Title from "../../../components/Admin/Title";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useUser } from "../../../components/UserContext";
import { toast } from "react-toastify";
import { TagsInput } from "react-tag-input-component";
import Papa from "papaparse";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";

const GenerateXMLHCFileRBR = () => {
  const { access } = useIsAdmin();
  const [sessions, setSessions] = useState(3);
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState<any>({});
  const [tags, setTags] = useState<string[]>([]);
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");

  const handleFileChange = (e: any, index: string) => {
    const newResults = { ...results };
    const file = e.target.files[0];

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        newResults[index] = results.data;
        setResults(newResults);
      },
    });
  };

  const submitForm = async (event: any) => {
    if (token == null) return;
    event.preventDefault();
    const formData = new FormData();
    formData.append("user", user);
    formData.append("token", JSON.parse(token).token);
    formData.append("sessions", sessions + "");
    formData.append("results", JSON.stringify(results));
    formData.append("tags", JSON.stringify(tags));

    try {
      await axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/generateXMLHCFileRBR`,
          formData
        )
        .then((response) => {
          // Create a Blob from the response
          const blob = new Blob([response.data], { type: "application/xml" });

          // Create a URL for the Blob
          const url = window.URL.createObjectURL(blob);

          // Create a link and set it up for downloading
          const a = document.createElement("a");
          a.href = url;
          a.download = "data.xml";

          // Simulate a click on the link to start downloading
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(({ response }) => {
          toast.error(`Error: ${response.data.message}`);
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    } catch (error) {
      console.error("Error al enviar los archivos:", error);
    }
  };

  const renderSessions = () => {
    const formGroups = [];

    for (let i = 1; i <= sessions; i++) {
      formGroups.push(
        <Form.Group className="form-group" as={Row} md="12" key={`h${i}`}>
          <Form.Label>{`Session ${i} (csv beta)`}</Form.Label>
          <Form.Control
            name={`file_${i}`}
            type="file"
            required
            accept=".csv"
            onChange={(e) => handleFileChange(e, `${i}`)}
          />
          <Form.Control.Feedback type="invalid">
            Field required
          </Form.Control.Feedback>
        </Form.Group>
      );
    }

    return formGroups;
  };

  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Generate XML HC File" />
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Sessions (*)</Form.Label>
              <Form.Control
                name="sessions"
                type="number"
                required
                min={1}
                onChange={(e) => setSessions(parseInt(e.target.value))}
                value={sessions}
              />
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Drivers to ignore</Form.Label>
              <TagsInput
                value={tags}
                onChange={setTags}
                name="tags"
                placeHolder="Type and press Enter"
              />
            </Form.Group>
            {renderSessions()}
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button variant="primary" type="submit">
                Download XML HC File
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default GenerateXMLHCFileRBR;
